import { call } from "redux-saga/effects";

import API from "modules/api/api";
import { composeSaga, withErrorHandling } from "modules/root/saga-helpers";

function* fetchHelpTextImpl(helpTextKey) {
  return yield call(API.user.getHelpText, helpTextKey);
}

export const fetchHelpText = composeSaga(withErrorHandling, fetchHelpTextImpl);



// WEBPACK FOOTER //
// ./src/modules/modal/modal-api-saga.js